'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchGetConfiguration = exports.SOAP_VERSION = exports.WEB_METHOD = exports.DELETE_OUTPUT = exports.CREATE_OUTPUT = exports.UPDATE_INPUT_VALUE = exports.UPDATE_INPUT_NAME = exports.UPDATE_INPUT = exports.DELETE_INPUT = exports.CREATE_INPUT = exports.WSDL_SUCCESS = exports.WSDL_INVALID_ERROR = exports.WSDL_PARSE_ERROR = exports.WSDL_READ_ERROR = exports.WSDL_LOADING = exports.VALUE = exports.TOGGLE_PUSH_QUOTES = exports.SET_SEND_COMMAND = exports.TOGGLE_SEND_COMMAND = exports.TOGGLE_SEND_EMAIL = exports.TOGGLE_DELETE_ON_SEND = exports.ACTIVE = exports.watchSaveConfiguration = exports.saveConfiguration = exports.getConfiguration = exports.soapVersion = exports.webMethod = exports.togglePushQuotes = exports.setSendCommand = exports.toggleCached = exports.toggleSendCommand = exports.toggleSendEmail = exports.updateInputValue = exports.updateInputName = exports.updateInput = exports.deleteInput = exports.createInput = exports.wsdlSuccess = exports.wsdlInvalidError = exports.wsdlParseError = exports.wsdlReadError = exports.wsdlLoading = exports.deleteQuotesOnSendValue = exports.toggleDeleteQuotesOnSend = exports.deleteQuotesOnSendActive = exports.toggleDeleteSelected = exports.toggleDeleteAll = exports.changeCannedRulesProperty = exports.deleteCannedRule = exports.confirmEditCannedRule = exports.editCannedRule = exports.addCannedRule = exports.changeEmailSettingsProperty = exports.watchGetStorageOptions = exports.fetchStorageOptionsSaga = exports.changeStorageOptionProperty = exports.getStorageOptions = exports.GET_STORAGEOPTIONS_TYPES = exports.watchSaveGenericSettings = exports.watchGetGenericSettings = exports.saveGenericSettingsSaga = exports.fetchGenericSettingsSaga = exports.cancelGenericSettings = exports.saveGenericSettings = exports.getGenericSettings = exports.GET_GENERICSETTINGS_TYPES = exports.SAVE_GENERICSETTINGS_TYPES = exports.CANCEL = undefined;

var _genericSettings = require('./genericSettings');

Object.defineProperty(exports, 'CANCEL', {
  enumerable: true,
  get: function get() {
    return _genericSettings.CANCEL;
  }
});
Object.defineProperty(exports, 'SAVE_GENERICSETTINGS_TYPES', {
  enumerable: true,
  get: function get() {
    return _genericSettings.SAVE_GENERICSETTINGS_TYPES;
  }
});
Object.defineProperty(exports, 'GET_GENERICSETTINGS_TYPES', {
  enumerable: true,
  get: function get() {
    return _genericSettings.GET_GENERICSETTINGS_TYPES;
  }
});
Object.defineProperty(exports, 'getGenericSettings', {
  enumerable: true,
  get: function get() {
    return _genericSettings.getGenericSettings;
  }
});
Object.defineProperty(exports, 'saveGenericSettings', {
  enumerable: true,
  get: function get() {
    return _genericSettings.saveGenericSettings;
  }
});
Object.defineProperty(exports, 'cancelGenericSettings', {
  enumerable: true,
  get: function get() {
    return _genericSettings.cancelGenericSettings;
  }
});
Object.defineProperty(exports, 'fetchGenericSettingsSaga', {
  enumerable: true,
  get: function get() {
    return _genericSettings.fetchGenericSettingsSaga;
  }
});
Object.defineProperty(exports, 'saveGenericSettingsSaga', {
  enumerable: true,
  get: function get() {
    return _genericSettings.saveGenericSettingsSaga;
  }
});
Object.defineProperty(exports, 'watchGetGenericSettings', {
  enumerable: true,
  get: function get() {
    return _genericSettings.watchGetGenericSettings;
  }
});
Object.defineProperty(exports, 'watchSaveGenericSettings', {
  enumerable: true,
  get: function get() {
    return _genericSettings.watchSaveGenericSettings;
  }
});

var _configuration = require('./configuration');

Object.defineProperty(exports, 'GET_STORAGEOPTIONS_TYPES', {
  enumerable: true,
  get: function get() {
    return _configuration.GET_STORAGEOPTIONS_TYPES;
  }
});
Object.defineProperty(exports, 'getStorageOptions', {
  enumerable: true,
  get: function get() {
    return _configuration.getStorageOptions;
  }
});
Object.defineProperty(exports, 'changeStorageOptionProperty', {
  enumerable: true,
  get: function get() {
    return _configuration.changeStorageOptionProperty;
  }
});
Object.defineProperty(exports, 'fetchStorageOptionsSaga', {
  enumerable: true,
  get: function get() {
    return _configuration.fetchStorageOptionsSaga;
  }
});
Object.defineProperty(exports, 'watchGetStorageOptions', {
  enumerable: true,
  get: function get() {
    return _configuration.watchGetStorageOptions;
  }
});

var _emailSettings = require('./emailSettings');

Object.defineProperty(exports, 'changeEmailSettingsProperty', {
  enumerable: true,
  get: function get() {
    return _emailSettings.changeEmailSettingsProperty;
  }
});

var _cannedRules = require('./cannedRules');

Object.defineProperty(exports, 'addCannedRule', {
  enumerable: true,
  get: function get() {
    return _cannedRules.addCannedRule;
  }
});
Object.defineProperty(exports, 'editCannedRule', {
  enumerable: true,
  get: function get() {
    return _cannedRules.editCannedRule;
  }
});
Object.defineProperty(exports, 'confirmEditCannedRule', {
  enumerable: true,
  get: function get() {
    return _cannedRules.confirmEditCannedRule;
  }
});
Object.defineProperty(exports, 'deleteCannedRule', {
  enumerable: true,
  get: function get() {
    return _cannedRules.deleteCannedRule;
  }
});
Object.defineProperty(exports, 'changeCannedRulesProperty', {
  enumerable: true,
  get: function get() {
    return _cannedRules.changeCannedRulesProperty;
  }
});

var _oldCFA = require('./oldCFA');

Object.defineProperty(exports, 'toggleDeleteAll', {
  enumerable: true,
  get: function get() {
    return _oldCFA.toggleDeleteAll;
  }
});
Object.defineProperty(exports, 'toggleDeleteSelected', {
  enumerable: true,
  get: function get() {
    return _oldCFA.toggleDeleteSelected;
  }
});
Object.defineProperty(exports, 'deleteQuotesOnSendActive', {
  enumerable: true,
  get: function get() {
    return _oldCFA.deleteQuotesOnSendActive;
  }
});
Object.defineProperty(exports, 'toggleDeleteQuotesOnSend', {
  enumerable: true,
  get: function get() {
    return _oldCFA.toggleDeleteQuotesOnSend;
  }
});
Object.defineProperty(exports, 'deleteQuotesOnSendValue', {
  enumerable: true,
  get: function get() {
    return _oldCFA.deleteQuotesOnSendValue;
  }
});
Object.defineProperty(exports, 'wsdlLoading', {
  enumerable: true,
  get: function get() {
    return _oldCFA.wsdlLoading;
  }
});
Object.defineProperty(exports, 'wsdlReadError', {
  enumerable: true,
  get: function get() {
    return _oldCFA.wsdlReadError;
  }
});
Object.defineProperty(exports, 'wsdlParseError', {
  enumerable: true,
  get: function get() {
    return _oldCFA.wsdlParseError;
  }
});
Object.defineProperty(exports, 'wsdlInvalidError', {
  enumerable: true,
  get: function get() {
    return _oldCFA.wsdlInvalidError;
  }
});
Object.defineProperty(exports, 'wsdlSuccess', {
  enumerable: true,
  get: function get() {
    return _oldCFA.wsdlSuccess;
  }
});
Object.defineProperty(exports, 'createInput', {
  enumerable: true,
  get: function get() {
    return _oldCFA.createInput;
  }
});
Object.defineProperty(exports, 'deleteInput', {
  enumerable: true,
  get: function get() {
    return _oldCFA.deleteInput;
  }
});
Object.defineProperty(exports, 'updateInput', {
  enumerable: true,
  get: function get() {
    return _oldCFA.updateInput;
  }
});
Object.defineProperty(exports, 'updateInputName', {
  enumerable: true,
  get: function get() {
    return _oldCFA.updateInputName;
  }
});
Object.defineProperty(exports, 'updateInputValue', {
  enumerable: true,
  get: function get() {
    return _oldCFA.updateInputValue;
  }
});
Object.defineProperty(exports, 'toggleSendEmail', {
  enumerable: true,
  get: function get() {
    return _oldCFA.toggleSendEmail;
  }
});
Object.defineProperty(exports, 'toggleSendCommand', {
  enumerable: true,
  get: function get() {
    return _oldCFA.toggleSendCommand;
  }
});
Object.defineProperty(exports, 'toggleCached', {
  enumerable: true,
  get: function get() {
    return _oldCFA.toggleCached;
  }
});
Object.defineProperty(exports, 'setSendCommand', {
  enumerable: true,
  get: function get() {
    return _oldCFA.setSendCommand;
  }
});
Object.defineProperty(exports, 'togglePushQuotes', {
  enumerable: true,
  get: function get() {
    return _oldCFA.togglePushQuotes;
  }
});
Object.defineProperty(exports, 'webMethod', {
  enumerable: true,
  get: function get() {
    return _oldCFA.webMethod;
  }
});
Object.defineProperty(exports, 'soapVersion', {
  enumerable: true,
  get: function get() {
    return _oldCFA.soapVersion;
  }
});
Object.defineProperty(exports, 'getConfiguration', {
  enumerable: true,
  get: function get() {
    return _oldCFA.getConfiguration;
  }
});
Object.defineProperty(exports, 'saveConfiguration', {
  enumerable: true,
  get: function get() {
    return _oldCFA.saveConfiguration;
  }
});
Object.defineProperty(exports, 'watchSaveConfiguration', {
  enumerable: true,
  get: function get() {
    return _oldCFA.watchSaveConfiguration;
  }
});
Object.defineProperty(exports, 'ACTIVE', {
  enumerable: true,
  get: function get() {
    return _oldCFA.ACTIVE;
  }
});
Object.defineProperty(exports, 'TOGGLE_DELETE_ON_SEND', {
  enumerable: true,
  get: function get() {
    return _oldCFA.TOGGLE_DELETE_ON_SEND;
  }
});
Object.defineProperty(exports, 'TOGGLE_SEND_EMAIL', {
  enumerable: true,
  get: function get() {
    return _oldCFA.TOGGLE_SEND_EMAIL;
  }
});
Object.defineProperty(exports, 'TOGGLE_SEND_COMMAND', {
  enumerable: true,
  get: function get() {
    return _oldCFA.TOGGLE_SEND_COMMAND;
  }
});
Object.defineProperty(exports, 'SET_SEND_COMMAND', {
  enumerable: true,
  get: function get() {
    return _oldCFA.SET_SEND_COMMAND;
  }
});
Object.defineProperty(exports, 'TOGGLE_PUSH_QUOTES', {
  enumerable: true,
  get: function get() {
    return _oldCFA.TOGGLE_PUSH_QUOTES;
  }
});
Object.defineProperty(exports, 'VALUE', {
  enumerable: true,
  get: function get() {
    return _oldCFA.VALUE;
  }
});
Object.defineProperty(exports, 'WSDL_LOADING', {
  enumerable: true,
  get: function get() {
    return _oldCFA.WSDL_LOADING;
  }
});
Object.defineProperty(exports, 'WSDL_READ_ERROR', {
  enumerable: true,
  get: function get() {
    return _oldCFA.WSDL_READ_ERROR;
  }
});
Object.defineProperty(exports, 'WSDL_PARSE_ERROR', {
  enumerable: true,
  get: function get() {
    return _oldCFA.WSDL_PARSE_ERROR;
  }
});
Object.defineProperty(exports, 'WSDL_INVALID_ERROR', {
  enumerable: true,
  get: function get() {
    return _oldCFA.WSDL_INVALID_ERROR;
  }
});
Object.defineProperty(exports, 'WSDL_SUCCESS', {
  enumerable: true,
  get: function get() {
    return _oldCFA.WSDL_SUCCESS;
  }
});
Object.defineProperty(exports, 'CREATE_INPUT', {
  enumerable: true,
  get: function get() {
    return _oldCFA.CREATE_INPUT;
  }
});
Object.defineProperty(exports, 'DELETE_INPUT', {
  enumerable: true,
  get: function get() {
    return _oldCFA.DELETE_INPUT;
  }
});
Object.defineProperty(exports, 'UPDATE_INPUT', {
  enumerable: true,
  get: function get() {
    return _oldCFA.UPDATE_INPUT;
  }
});
Object.defineProperty(exports, 'UPDATE_INPUT_NAME', {
  enumerable: true,
  get: function get() {
    return _oldCFA.UPDATE_INPUT_NAME;
  }
});
Object.defineProperty(exports, 'UPDATE_INPUT_VALUE', {
  enumerable: true,
  get: function get() {
    return _oldCFA.UPDATE_INPUT_VALUE;
  }
});
Object.defineProperty(exports, 'CREATE_OUTPUT', {
  enumerable: true,
  get: function get() {
    return _oldCFA.CREATE_OUTPUT;
  }
});
Object.defineProperty(exports, 'DELETE_OUTPUT', {
  enumerable: true,
  get: function get() {
    return _oldCFA.DELETE_OUTPUT;
  }
});
Object.defineProperty(exports, 'WEB_METHOD', {
  enumerable: true,
  get: function get() {
    return _oldCFA.WEB_METHOD;
  }
});
Object.defineProperty(exports, 'SOAP_VERSION', {
  enumerable: true,
  get: function get() {
    return _oldCFA.SOAP_VERSION;
  }
});

var _configSaga = require('./configSaga');

Object.defineProperty(exports, 'watchGetConfiguration', {
  enumerable: true,
  get: function get() {
    return _configSaga.watchGetConfiguration;
  }
});

var _redux = require('redux');

var _configuration2 = _interopRequireDefault(_configuration);

var _emailSettings2 = _interopRequireDefault(_emailSettings);

var _cannedRules2 = _interopRequireDefault(_cannedRules);

var _genericSettings2 = _interopRequireDefault(_genericSettings);

var _oldCFA2 = _interopRequireDefault(_oldCFA);

var _configSaga2 = _interopRequireDefault(_configSaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var genericSettings = (0, _redux.combineReducers)({
  configuration: _configuration2.default,
  emailSettings: _emailSettings2.default,
  cannedRules: _cannedRules2.default,
  status: _genericSettings2.default,
  oldCFA: _oldCFA2.default

});

exports.default = genericSettings;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/index.js
// module id = 38
// module chunks = 0